<template>
  <Root>
    <AuthFormModal />
    <ManageCookiesPolicyModal />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </Root>
</template>
